import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "/api",
    timeout: 25000,
    headers: { Accept: "application/json" },
});

// attach token from localStorage if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

export function setAuthToken(token) {
    if (token) {
        localStorage.setItem("token", token);
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        localStorage.removeItem("token");
        delete api.defaults.headers.common["Authorization"];
    }
}

// Response interceptor: handle 401s (expired or invalid token)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        try {
            const res = error.response;
            if (res && res.status === 401) {
                const msg = (res.data && res.data.message) ? String(res.data.message).toLowerCase() : '';
                if (msg.includes('expired') || msg.includes('invalid token') || msg.includes('invalid') || msg.includes('unauthenticated')) {
                    try {
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        localStorage.removeItem('roles');
                        localStorage.removeItem('role');
                        localStorage.removeItem('permissions');
                        delete api.defaults.headers.common['Authorization'];
                    } catch (e) {
                        // ignore storage errors
                    }
                    if (typeof window !== 'undefined') {
                        window.location.href = '/login';
                    }
                }
            }
        } catch (e) {
            // ignore interceptor errors
        }
        return Promise.reject(error);
    }
);

export default api;
